<template>
        <div class="pa-9 py-6">
        <div class="d-flex justify-space-between align-center">
            <div class="text-h4"><strong>Grid #0000</strong></div>
            <div class="text-p">
                <span class="ml-2">
                    <v-icon>mdi-user</v-icon>
                    <strong>Cliente:</strong> AIQFOME LTDA
                </span>
                <span class="ml-2">
                    <strong>Documento:</strong> 00.000.000/0000-00
                </span>
            </div>
        </div>
        <div class="mt-6"> 
            <v-expansion-panels hide-actions>
                <order-item v-for="(item, index) in orders" :order="item" :key="item.id" :index="index"></order-item>
            </v-expansion-panels>
        </div>
        <PiCancelReason v-if="open.piCancelReason"></PiCancelReason>
        <PiPaymentChange v-if="open.piPaymentChange"></PiPaymentChange>
    </div>
</template>
<script>
import OrderItem from '@/components/OrderItem.vue';
import PiCancelReason from '@/components/dialogs/PiCancelReason.vue';
import PiPaymentChange from '@/components/dialogs/PiPaymentChange.vue';
    export default {
    name: 'OrdersView',
    components: { OrderItem, PiCancelReason, PiPaymentChange },
    data: () => ({
        documents: [],
        open: {
            piCancelReason: false,
            piPaymentChange: false
        },
        assets: [], 
        orders: [
            {id: 1},
            {id: 2},
            {id: 3},
            {id: 9}
        ]
    }),
    mounted(){
        this.getAssets()
    },  
    methods: {
        getAssets(){
            
        }
    }
}
</script>